"use client";
import { getControlClassNames as e } from "../controls/control-class-names.js";
import { ControlIcon as t } from "../controls/ControlIcon.js";
import { Button as n } from "../button/Button.js";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
//#region src/components/feedback/FeedbackAction.tsx
var a = ({ action: a, variant: o }) => a.href === void 0 ? /* @__PURE__ */ r(n, {
	variant: o,
	size: "sm",
	onClick: a.onClick,
	disabled: a.disabled,
	disabledReason: a.disabledReason,
	loadingConfig: a.loadingConfig,
	leadingIcon: a.leadingIcon,
	children: a.label
}) : /* @__PURE__ */ i("a", {
	href: a.href,
	target: a.target,
	rel: a.rel ?? (a.target === "_blank" ? "noopener noreferrer" : void 0),
	className: e({
		variant: o,
		size: "sm"
	}),
	children: [a.leadingIcon && /* @__PURE__ */ r(t, {
		size: 16,
		children: a.leadingIcon
	}), /* @__PURE__ */ r("span", {
		className: "pf:min-w-0 pf:wrap-anywhere",
		children: a.label
	})]
});
//#endregion
export { a as FeedbackActionControl };
